module.exports = __webpack_public_path__ + "static/img/brandLiNian.4e82961.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/huaiBrand/brandLiNian.png
// module id = MAnL
// module chunks = 0